import React, { Component } from 'react';
import { InputNumber, Card, Form, Row, Col, Button } from 'antd';
import './index.less';

const FormItem = Form.Item;
class ProtectSetIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Card title="保护设置" className="protectSet">
        <Form layout="inline" onSubmit={this.handleSubmit}>
          <Row gutter={{ md: 8, lg: 24, xl: 48 }}>
            <Col md={8} sm={24}>
              <FormItem>
                保护有效期
                {getFieldDecorator('condition')(<InputNumber />)}天
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem>
                合同到期
                {getFieldDecorator('condition')(<InputNumber />)}
                天后保护有效期
                {getFieldDecorator('condition')(<InputNumber />)}天
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem>
                保护上限
                {getFieldDecorator('condition')(<InputNumber />)}个
              </FormItem>
            </Col>
            <Col md={8} sm={24}>
              <FormItem>
                <Button type="primary">确定</Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(ProtectSetIndex);



// WEBPACK FOOTER //
// ./src/components/client/protectSet/Index.js